import { render, staticRenderFns } from "./PopupConfirmAction.vue?vue&type=template&id=b8ca30c8&scoped=true&"
import script from "./PopupConfirmAction.vue?vue&type=script&lang=js&"
export * from "./PopupConfirmAction.vue?vue&type=script&lang=js&"
import style0 from "./PopupConfirmAction.vue?vue&type=style&index=0&id=b8ca30c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca30c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VSpacer})
